import axiosInstance from ".";

export const getBlogs = (term = "") => {
  return axiosInstance.get("/faq", {
    params: {
      term: term,
    },
  });
};

export const addFaq = (data) => {
  return axiosInstance.post("/faq", data);
};

export const updateFaq = (data) => {
  const { id, ...payload } = data;
  return axiosInstance.put(`/faq/${id}`, payload);
};

export const deleteFaq = (id) => {
  return axiosInstance.delete(`/faq/${id}`);
};

export const getFaqs = ({ queryKey }) => {
  const [queries] = queryKey;
  return axiosInstance.get(`/faq`, { params: queries });
};
